import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { AuthProvider } from './contexts/AuthContext';
import { NexusProvider } from './contexts/NexusContext';
import { TaxProvider } from './contexts/TaxContext';
import AppRoutes from './routes';
import DevWatermark from './components/DevWatermark';
import { SessionTimeoutManager } from './components/SessionTimeoutManager';

const App: React.FC = () => {
    return (
        <HelmetProvider>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <Router>
                    <AuthProvider>
                        <SessionTimeoutManager />
                        <NexusProvider>
                            <TaxProvider>
                                <AppRoutes />
                                <DevWatermark />
                            </TaxProvider>
                        </NexusProvider>
                    </AuthProvider>
                </Router>
            </ThemeProvider>
        </HelmetProvider>
    );
};

export default App; 
